import { CANONICAL_UUID } from './format';

/** A real Gregorian calendar day, the rule the backend applies to `date` and `date-time`. */
function isCalendarDay(year: number, month: number, day: number): boolean {
  const leap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
  const maxDay = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month - 1];
  return year !== 0 && maxDay !== undefined && day >= 1 && day <= maxDay;
}

/**
 * The formats the Panel validates contracts with: the same formats as the canonical validatorSource; `date` is the
 * backend's date-only wire format (`YYYY-MM-DD`), which strict Ajv would otherwise refuse to compile. The validators
 * generated at build time (`scripts/contract-validators.mjs`) and the registry compiled in the specs both use these.
 */
export const CONTRACT_FORMATS = Object.freeze({
  uuid: CANONICAL_UUID,
  'date-time': (value: string) => {
    const match = /^(\d{4})-(\d{2})-(\d{2})T(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z|[+-](?:[01]\d|2[0-3]):[0-5]\d)$/i.exec(value);
    return match !== null && isCalendarDay(Number(match[1]), Number(match[2]), Number(match[3]));
  },
  date: (value: string) => {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    return match !== null && isCalendarDay(Number(match[1]), Number(match[2]), Number(match[3]));
  },
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  uri: (value: string) => {
    try { return Boolean(new URL(value).protocol); } catch { return false; }
  },
  binary: () => true,
});
